import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { DsProgressCircleModule, ISizeInput } from '@bmw-ds/components';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

export type LoadingComponentSize = number | ISizeInput;
export type LoadingComponentMargin = `m-${number}x` | '';

@Component({
  selector: 'pure-loading',
  imports: [CommonModule, DsProgressCircleModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent implements ILoadingOverlayAngularComp {
  size = input<LoadingComponentSize>(60);
  margin = input<LoadingComponentMargin>('');

  params!: ILoadingOverlayParams;

  agInit(params: ILoadingOverlayParams): void {
    this.params = params;
  }
}
